import { useCallback } from 'react';

import {
  ConvertableTypes,
  CreditNote,
} from '@work4all/components/lib/components/convert-popover/ConvertableTypes';

import { usePermissions } from '@work4all/data';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

export const useCanFilterEntitiesByPermission = () => {
  const { canAdd } = usePermissions();

  const filterEntitiesByPermission = useCallback(
    (entity: ConvertableTypes) => {
      if (entity === CreditNote) return canAdd({ entity: Entities.invoice });
      return canAdd({ entity });
    },
    [canAdd]
  );

  return { filterEntitiesByPermission };
};
